import { render, staticRenderFns } from "./TabFolio.vue?vue&type=template&id=901e6400&scoped=true&"
import script from "./TabFolio.vue?vue&type=script&lang=js&"
export * from "./TabFolio.vue?vue&type=script&lang=js&"
import style0 from "./TabFolio.vue?vue&type=style&index=0&id=901e6400&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901e6400",
  null
  
)

export default component.exports